<template>
    <div>
        <h2
            class="pt-2 px-4 subtitle-1 font-weight-bold"
            tabindex="0"
            aria-hidden="false"
            data-testId="apptTimeTitle"
            :aria-label="$t('appt.apptTimeTitleAriaLabel')"
            id="apptTimeTitle"
        >
            <v-tooltip bottom slot="prepend">
                <template v-slot:activator="{ on }">
                    <v-icon tabindex="-1" aria-hidden="true" role="img" v-on="on">
                        access_time
                    </v-icon>
                </template>
                <div>{{ $t('appt.tooltips.time') }}</div>
            </v-tooltip>
            {{ $t('appt.apptTimeTitle') }}
            <br v-if="$vuetify.breakpoint.smAndDown" />
            <show-timezone-code
                :virtual-service="virtualAccount"
                class="font-weight-bold"
            />
        </h2>
        <hr aria-hidden="true" class="mb-2 mx-4" />
    </div>
</template>

<script>
import ShowTimezoneCode from '@/components/timezones/ShowTimezoneCode';
export default {
    name: 'time-slots-header',
    components: {
        ShowTimezoneCode,
    },
    props: {
        virtualAccount: { type: String, required: true },
    },
};
</script>

<style lang="scss" scoped>
</style>
